module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0094.jpg?v=f9df1732";